import options from './component';


export default {
    selector: "dtEmulatorWaterDetector",
    options
}